import Button from '@bugbug/core/components/Button';
import styled from 'styled-components';

export const Container = styled.div`
  padding: 24px 36px;
  display: flex;
  align-items: center;
  gap: 15px;
  background: ${(props) => props.theme.colors.background.highlightLight};
  border-radius: 6px;
`;

export const Title = styled.p`
  font-size: 14px;
  line-height: 1.5;
  font-weight: ${(props) => props.theme.fontWeight.bold};
  margin: 0;
`;

export const Description = styled.p`
  line-height: 1.5;
  margin: 0;
`;

export const CancelDowngradeButton = styled(Button)`
  margin-left: auto;
`;
